
import Vue from "vue";
export default Vue.extend({
  name: "AccessDeniedComponent",
  props: {
    title: {
      type: String
    },
    camera_and_microphone: {
      type: Boolean
    }
  }
});
